// extracted by mini-css-extract-plugin
export default {"layout_body":"index_layout_body_5--xU","content_list":"index_content_list_tt9hV","chip_item":"index_chip_item_mTBM1"};